import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import DailyStatistics from '../daily-statistics/DailyStatistics';

const ContactosHeader = () => {
    return (
        <>
            <Card className="mb-1 p-2">
                <Row className="g-2 align-items-sm-center">
                    <Col xs="auto">
                        <img src="/img/cliente96.png" alt="connectCircle" height={30} />
                    </Col>
                    <Col>
                        <h5>Leads</h5>
                    </Col>
                </Row>
                <Row>
                    
                </Row>
            </Card>
            <DailyStatistics />
        </>
    );
};

ContactosHeader.propTypes = {
    cargando: PropTypes.bool,
    vendedor: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default ContactosHeader;
